import type React from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const MacCommandIcon: React.FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props} data-test-id="mac-command-icon">
    <path
      fill="currentColor"
      d="M23 4a5 5 0 0 1 0 10h-3v4h3a5 5 0 1 1-5 5v-3h-4v3a5 5 0 1 1-5-5h3v-4H9a5 5 0 1 1 5-5v3h4V9a5 5 0 0 1 5-5ZM9 20a3 3 0 1 0 3 3v-3H9Zm11 0v3a3 3 0 1 0 3-3h-3Zm-6-2h4v-4h-4v4ZM9 6a3 3 0 0 0 0 6h3V9a3 3 0 0 0-3-3Zm14 0a3 3 0 0 0-3 3v3h3a3 3 0 1 0 0-6Z"
    />
  </BaseIcon>
);
